import breadcrumbComp from "../../common/breadcrumb-comp.vue";
import Utility from "../../../shared/utility";
import EncryptUtility from "../../utility/js/encrypt-utility";
import AddFavourite from "../../utility/js/addFav";
import BackToTop from "../../common/back-to-top.vue";
import exportLimit from "../../common/export-limit.vue";
import reportingService from "./reporting-service";
import moment from "moment";
export default {
  data() {
    return {
      userId: EncryptUtility.localStorageDecrypt("userID"),
      actionList: [],
      favouriteList: [],
      selectedType: "1",
      isFormValid: false,
      typeList: [
        { Name: "Equals To", Pass: "1" },
        { Name: "Contains", Pass: "2" },
      ],
      max3Rule: [
        (v) => (v || "").length >= 3 || "Min Length of 3 character",
        (v) => (v || "").length > 0 || "Min Length of 3 character",
      ],
      mainPage: "",
      subPage: "",
      backSlash: true,
      isAllProjectSelected: false,
      runDisabled: true,
      isAllBusinessSelected: false,
      isAllWarehouseSelected: false,
      isAllParentClassSelected: false,
      isAllClassSelected: false,
      showStartDate: true,
      startDate: false,
      maxStartDate: new Date().toISOString().split("T")[0],
      minEndDate: new Date(new Date().getTime() - 86400000).toISOString().split("T")[0],
      showData: false,
      pageUrl: "",
      route: "",
      showAdd: false,
      refresh: true,
      endDate: false,
      showEndDate: true,
      maxEndDate: new Date(new Date().getTime()).toISOString().split("T")[0],
      projectList: [],
      partResultList: [],
      reportData: [],
      warehouseList: [],
      businessList: [],
      parentClassList: [],
      classList: [],
      shipMethodList: [],
      debouncedGetPartList: [],
      required: [(v) => parseInt(v) >= 0 || "Field is required"],
      showPart: true,
      hideSpecific: false,
      disableAll: false,
      specificSelected: false,
      disableSpecific: false,
      showPartNumDetails: false,
      showPartDetails: false,
      requiredText: [(v) => !!v || "Field is required"],
      partNum: "",
      partSearchKey: "",
      totalRecords: 0,
      partDesc: "",
      json_fields: {
        Project: "Project",
        Business: "Business",
        "Origin Number": "Origin_Number",
        "Origin SO RMA": "Origin_SORMA",
        "Origin PO RMA": "Origin_PORMA",
        Item: "Item",
        Description: "Description",
        Model: "Model",
        PClass: "PClass",
        Class: "Class",
        "Original BCN": "Original_BCN",
        "Original Serial No": "Original_Serialno",
        "Original ESN": "Original_ESN",
        "Original ICCID": "Original_ICCID",
        "New BCN": "New_BCN",
        "New Serial No": "New_Serialno",
        "New ESN": "New_ESN",
        "New ICCID": "New_ICCID",
        "Date Received": "Date_Rcvd",
        "Date Transferred": "Date_trans",
        Warehouse: "Warehouse",
      },
      reportObj: {
        execution_type: 1,
        asset: "",
        proj_key: "",
        bu_key: "",
        ware_key: "",
        parent_class_key: "",
        class_key: "",
        lcsdate: new Date().toISOString().substr(0, 10),
        ship_method: "",
        lcedate: new Date(new Date().getTime()).toISOString().substr(0, 10),
        user_id: EncryptUtility.localStorageDecrypt("userID"),
      },
      reportHeader: [
        {
          text: "Project",
          align: "start",
          value: "Project",
          class: "primary customwhite--text",
          width: "10%",
        },
        {
          text: "Business",
          value: "Business",
          class: "primary customwhite--text",
          width: "10%",
        },
        {
          text: "Origin Number",
          value: "Origin_Number",
          class: "primary customwhite--text",
          width: "10%",
        },
        {
          text: "Origin SO RMA",
          value: "Origin_SORMA",
          class: "primary customwhite--text",
          width: "10%",
        },
        {
          text: "Origin PO RMA",
          value: "Origin_PORMA",
          class: "primary customwhite--text",
          width: "10%",
        },
        { text: "Item", value: "Item", class: "primary customwhite--text", width: "150px" },
        {
          text: "Description",
          value: "Description",
          class: "primary customwhite--text",
          width: "10%",
        },
        { text: "Model", value: "Model", class: "primary customwhite--text", width: "10%" },
        {
          text: "Parent Class",
          value: "PClass",
          class: "primary customwhite--text",
          width: "10%",
        },
        {
          text: "Class",
          value: "Class",
          class: "primary customwhite--text",
          width: "10%",
        },
        {
          text: "Original BCN",
          value: "Original_BCN",
          class: "primary customwhite--text",
          width: "10%",
        },
        {
          text: "Original SerialNo",
          value: "Original_Serialno",
          class: "primary customwhite--text",
          width: "10%",
        },
        {
          text: "Original ESN",
          value: "Original_ESN",
          class: "primary customwhite--text",
          width: "10%",
        },
        {
          text: "Original ICCID",
          value: "Original_ICCID",
          class: "primary customwhite--text",
          width: "10%",
        },
        {
          text: "New BCN",
          value: "New_BCN",
          class: "primary customwhite--text",
          width: "10%",
        },
        {
          text: "New SerialNo",
          value: "New_Serialno",
          class: "primary customwhite--text",
          width: "10%",
        },
        {
          text: "New ESN",
          value: "New_ESN",
          class: "primary customwhite--text",
          width: "10%",
        },
        {
          text: "New ICCID",
          value: "New_ICCID",
          class: "primary customwhite--text",
          width: "10%",
        },
        {
          text: "Date Received",
          value: "Date_Rcvd",
          class: "primary customwhite--text",
          width: "10%",
        },
        {
          text: "Date Transaction",
          value: "Date_trans",
          class: "primary customwhite--text",
          width: "10%",
        },
        {
          text: "Warehouse",
          value: "Warehouse",
          class: "primary customwhite--text",
          width: "10%",
        },
      ],
    };
  },
  async created() {
    this.route = this.$route.path.replace("/", "");
    let data = await AddFavourite.getPageAction(this.userId, this.route);
    this.actionList = data.actionList;
    this.mainPage = data.mainPage;
    this.favouriteList = data.favouriteList;
    this.pageUrl = data.pageUrl;
    this.subPage = data.subPage;
    this.showAdd = data.showAdd;
    this.debouncedGetPartList = Utility.debounce(this.getPartList, 500);
    this.getProjectData();
    this.finalReportObj = JSON.parse(JSON.stringify(this.reportObj));
  },
  computed: {
    processedProjectList() {
      return this.createProcessedList(this.projectList, this.isAllProjectSelected, "value_id", 0);
    },
    processedBusinessList() {
      return this.createProcessedList(this.businessList, this.isAllBusinessSelected, "bu_key", 0);
    },
    processedWarehouseList() {
      return this.createProcessedList(this.warehouseList, this.isAllWarehouseSelected, "ware_key", 0);
    },
    processedParentClassList() {
      return this.createProcessedList(this.parentClassList, this.isAllParentClassSelected, "parent_class_key", 0);
    },
    procressedClassList() {
      return this.createProcessedList(this.classList, this.isAllClassSelected, "class_key", 0);
    },
    lceDateFormattedMomentjs() {
      return this.reportObj.lcedate ? moment(String(this.reportObj.lcedate)).format("MM/DD/YYYY") : "";
    },
    lcsDateFormattedMomentjs() {
      return this.reportObj.lcsdate ? moment(this.reportObj.lcsdate).format("MM/DD/YYYY") : moment(new Date()).format("MM/DD/YYYY");
    },
    excelFileName() {
      return Utility.excelFileName("Asset Change Rate");
    },
  },
  methods: {
    addFav() {
      this.showAdd = !this.showAdd;
      AddFavourite.add_remove_Favourite(this.showAdd, this.userId, this.route);
    },
    async getProjectData() {
      let projectData = await reportingService.getReportingGenericProjectList("get", this.userId);
      if (projectData !== undefined && projectData !== null) {
        this.projectList = projectData;
      } else {
        this.projectList = [];
      }
    },
    actionSetter(action) {
      if (this.actionList !== undefined && this.actionList !== null && this.actionList !== "") {
        let filter = this.actionList.filter((entry) => entry.SystemName === action);
        return filter !== undefined && filter !== null && filter?.length == 1 ? true : false;
      } else return false;
    },
    onClickAll() {
      this.runDisabled = false;
      this.hideSpecific = true;
      this.reportObj.part_num = "0";
    },
    createProcessedList(list, isAllSelected, idKey = "value_id", allValueId = 0) {
      // Use optional chaining ?. in case the list is initially null/undefined
      return (
        list?.map((item) => ({
          ...item,
          // Disable the item if the 'isAllSelected' flag is true AND the item's ID is not the 'ALL' ID
          disabled: isAllSelected && item[idKey] !== allValueId,
        })) || []
      ); // Return an empty array if the input list is null/undefined
    },
    /**
     * Handles the common logic for multi-select components where an "ALL" option exists.
     * Updates the corresponding reportObj key and the isAllSelected flag.
     * @param {Array} selectedKeys - The array of selected keys from the component.
     * @param {string} reportObjKey - The key in this.reportObj to update (e.g., 'proj_key').
     * @param {string} isAllSelectedFlagKey - The key in this data for the boolean flag (e.g., 'isAllProjectSelected').
     * @param {number|string} [allValueId=0] - The value representing the "ALL" option.
     */
    handleSelectionChange(selectedKeys, reportObjKey, isAllSelectedFlagKey, allValueId = 0) {
      const userSelectedAll = selectedKeys.includes(allValueId);
      const wasOnlyAllSelected = this[isAllSelectedFlagKey];
      if (userSelectedAll) {
        if (!wasOnlyAllSelected || selectedKeys?.length > 1) {
          this.reportObj[reportObjKey] = [allValueId];
        }
        this[isAllSelectedFlagKey] = true;
      } else {
        this[isAllSelectedFlagKey] = false;
      }
    },
    onChangeProject(selectedKeys) {
      this.handleSelectionChange(selectedKeys, "proj_key", "isAllProjectSelected", 0);
      this.businessList = [];
      this.warehouseList = [];
      this.parentClassList = [];
      this.classList = [];
      this.reportObj.bu_key = [];
      this.reportObj.ware_key = [];
      this.reportObj.parent_class_key = [];
      this.reportObj.class_key = [];
      this.reportObj.ship_method = "";
      this.specificSelected = false;
      this.showPart = true;
      this.isAllBusinessSelected = false;
      this.isAllWarehouseSelected = false;
      this.isAllParentClassSelected = false;
      this.reportObj.asset = "";
      this.reportData = [];
      this.totalRecords = 0;
      this.isAllClassSelected = false;
      this.clearPartShip();
      let businessObj = {
        execution_type: 1,
        proj_key: this.reportObj.proj_key?.toString(),
        user_id: this.userId,
      };
      if (this.reportObj.proj_key && this.reportObj.proj_key?.length > 0) {
        this.getBusinessData(businessObj);
      }
      this.showData = false;
      this.disableAll = false;
      this.hideSpecific = false;
    },
    async getBusinessData(businessObj) {
      let businessData = await reportingService.getReportingGenericBusinessList("post", businessObj);
      if (businessData && Array.isArray(businessData)) {
        this.businessList = businessData;
      } else {
        this.businessList = [];
      }
    },
    onChangeBusiness(selectedKeys) {
      this.handleSelectionChange(selectedKeys, "bu_key", "isAllBusinessSelected", 0);
      this.warehouseList = [];
      this.parentClassList = [];
      this.classList = [];
      this.reportObj.ware_key = [];
      this.reportObj.parent_class_key = [];
      this.reportObj.class_key = [];
      this.disableAll = false;
      this.isAllWarehouseSelected = false;
      this.isAllParentClassSelected = false;
      this.reportObj.ship_method = "";
      this.specificSelected = false;
      this.showPart = true;
      this.isAllClassSelected = false;
      this.reportData = [];
      this.totalRecords = 0;
      this.showPart = true;
      this.clearPartShip();
      let warehouseObj = {
        execution_type: 1,
        proj_key: this.reportObj.proj_key?.toString(),
        user_id: this.userId,
        bu_key: this.reportObj.bu_key?.toString(),
      };
      if (this.reportObj.bu_key && this.reportObj.bu_key?.length > 0) {
        this.getWarehouseData(warehouseObj);
      }
    },
    async getWarehouseData(warehouseObj) {
      let warehouseData = await reportingService.getReportingGenericWarehouseList("post", warehouseObj);
      if (warehouseData && Array.isArray(warehouseData)) {
        this.warehouseList = warehouseData;
      } else {
        this.warehouseList = [];
      }
    },
    onChangeWarehouse(selectedKeys) {
      this.handleSelectionChange(selectedKeys, "ware_key", "isAllWarehouseSelected", 0);
      this.parentClassList = [];
      this.classList = [];
      this.reportObj.parent_class_key = [];
      this.reportObj.class_key = [];
      this.isAllParentClassSelected = false;
      this.isAllClassSelected = false;
      this.reportData = [];
      this.totalRecords = 0;
      this.reportObj.ship_method = "";
      this.specificSelected = false;
      this.showPart = true;
      this.clearPartShip();
      let parentClassObj = {
        execution_type: 1,
        user_id: this.userId,
        bu_key: this.reportObj.bu_key?.toString(),
      };
      if (this.reportObj.ware_key && this.reportObj.ware_key?.length > 0) {
        this.getParentClassData(parentClassObj);
      }
    },
    async getParentClassData(parentClassObj) {
      let parentClassData = await reportingService.getReportingGenericParentClassList("post", parentClassObj);
      if (parentClassData && Array.isArray(parentClassData)) {
        this.parentClassList = parentClassData;
      } else {
        this.parentClassList = [];
      }
    },
    onChangeParentClass(selectedKeys) {
      this.handleSelectionChange(selectedKeys, "parent_class_key", "isAllParentClassSelected", 0);
      this.classList = [];
      this.reportObj.class_key = [];
      this.isAllClassSelected = false;
      this.reportObj.ship_method = "";
      this.specificSelected = false;
      this.showPart = true;
      this.clearPartShip();
      let classObj = {
        execution_type: 1,
        user_id: this.userId,
        bu_key: this.reportObj.bu_key?.toString(),
      };
      if (this.reportObj.parent_class_key && this.reportObj.parent_class_key?.length > 0) {
        this.getClassData(classObj);
      }
    },
    async getClassData(classObj) {
      let classData = await reportingService.getReportingGenericClassList("post", classObj);
      if (classData && Array.isArray(classData)) {
        this.classList = classData;
      } else {
        this.classList = [];
      }
    },
    async onChangeClass(selectedKeys) {
      this.handleSelectionChange(selectedKeys, "class_key", "isAllClassSelected", 0);
      this.shipMethodList = [];
      this.reportObj.ship_method = "";
      this.specificSelected = false;
      this.showPart = true;
      let shipData = await reportingService.getGenericShipmentList("get", this.userId);
      if (shipData && Array.isArray(shipData)) {
        this.shipMethodList = shipData;
      } else {
        this.shipMethodList = [];
      }
      this.reportData = [];
      this.totalRecords = 0;
      this.clearPartShip();
    },
    onClickSpecificPartNumber() {
      this.specificSelected = true;
    },
    async searchPartNum() {
      if (this.partSearchKey?.length > 2) {
        this.debouncedGetPartList();
      }
    },
    setEndDate() {
      let minEndDate = new Date(this.reportObj.lcsdate);
      this.minEndDate = new Date(minEndDate.getTime() + 0).toISOString().substr(0, 10);
      let maxSDate = new Date(this.maxStartDate);
      this.maxEndDate = new Date(maxSDate.getTime() + 0).toISOString().substr(0, 10);
    },
    async getPartList() {
      this.showPartNumDetails = true;
      let SearchObj = {
        user_id: this.userId,
        search_str: this.partSearchKey,
        proj_key: this.reportObj.proj_key?.toString(),
      };
      let partResultData = await reportingService.showPartNumDetailsData("post", SearchObj, false);
      this.partResultList = partResultData?.Resultset;
    },
    async showPartDesc(item) {
      this.showPartDetails = true;
      this.runDisabled = false;
      this.partNum = item.PartNo;
      this.partDesc = item.Description;
      this.partSearchKey = item.PartNo;
      this.showPartNumDetails = false;
      this.reportObj.part_num = this.partNum;
    },
    clearPartShip() {
      this.showPartDetails = false;
      this.partSearchKey = "";
      this.partResultList = [];
      this.partNum = "";
      this.partDesc = "";
    },
    onClickRunReport() {
      if (this.$refs.reportForm.validate()) {
        this.reportObj.asset = "";
        this.finalReportObj.asset = "";
        this.finalReportObj.proj_key = this.reportObj.proj_key?.toString();
        this.finalReportObj.bu_key = this.reportObj.bu_key?.toString();
        this.finalReportObj.ware_key = this.reportObj.ware_key?.toString();
        this.finalReportObj.parent_class_key = this.reportObj.parent_class_key?.toString();
        this.finalReportObj.class_key = this.reportObj.class_key?.toString();
        this.finalReportObj.ship_method = this.reportObj.ship_method?.toString();
        this.finalReportObj.part_num = this.reportObj.part_num;
        this.finalReportObj.lcedate = Utility.inputDateFormat(this.lceDateFormattedMomentjs, "23:59:59");
        this.finalReportObj.lcsdate = Utility.inputDateFormat(this.lcsDateFormattedMomentjs, "00:00:00");
        this.getTableData(this.finalReportObj);
      }
    },
    async onClickSearch() {
      let searchObj = {
        user_id: this.userId,
        SearchStr: this.reportObj.asset,
        SearchType: this.selectedType == "1" ? "Equals" : "Contains",
      };
      this.reportData = await reportingService.getAssetChangeReportFilter("post", searchObj);
      if (this.reportData && Array.isArray(this.reportData) && this.reportData.length > 0) {
        this.reportData.forEach((element) => {
          element.Date_Rcvd = Utility.displayDateFormat(element.Date_Rcvd);
          element.Date_trans = Utility.displayDateFormat(element.Date_trans);
        });
        this.showData = true;
        this.totalRecords = this.reportData.length;
      } else {
        this.showData = false;
        this.reportData = [];
        this.totalRecords = 0;
        this.$refs.reportForm.resetValidation();
        Utility.showNoDataToast("No Data Found");
      }
    },
    async getTableData(reportObj) {
      this.reportData = await reportingService.getAssetChangeReport("post", reportObj);
      if (this.reportData && Array.isArray(this.reportData) && this.reportData.length > 0) {
        this.reportData.forEach((element) => {
          element.Date_Rcvd = Utility.displayDateFormat(element.Date_Rcvd);
          element.Date_trans = Utility.displayDateFormat(element.Date_trans);
        });
        this.showData = true;
        this.totalRecords = this.reportData.length;
      } else {
        this.showData = false;
        this.reportData = [];
        this.totalRecords = 0;
        this.$refs.reportForm.resetValidation();
        Utility.validateForm("reportForm", this);
        Utility.showNoDataToast("No Data Found");
      }
    },
    resetFunction() {
      this.selectedType = "1";
      this.reportObj = {
        lcsdate: new Date().toISOString().substr(0, 10),
        proj_key: [],
        bu_key: [],
        ware_key: [],
        parent_class_key: [],
        class_key: [],
        ship_method: [],
        lcedate: new Date(new Date().getTime()).toISOString().substr(0, 10),
        user_id: this.userId,
        part_num: "",
        asset: "",
      };
      this.businessList = [];
      this.warehouseList = [];
      this.parentClassList = [];
      this.specificSelected = false;
      this.disableAll = false;
      this.partResultList = [];
      this.partNum = "";
      this.partDesc = "";
      this.classList = [];
      this.shipMethodList = [];
      this.isAllProjectSelected = false;
      this.isAllBusinessSelected = false;
      this.isAllWarehouseSelected = false;
      this.isAllParentClassSelected = false;
      this.isAllClassSelected = false;
      this.showPart = true;
      this.showPartDetails = false;
      this.hideSpecific = false;
      this.disableAll = false;
      this.runDisabled = true;
      this.clearPartShip();
      this.$refs.reportForm.resetValidation();
      this.showData = false;
      this.reportData = [];
      this.totalRecords = 0;
      this.getProjectData();
    },
    fileName() {
      Utility.exportExcel(this.reportData, this.json_fields, Utility.excelNewFileName("Asset_Change_Report_"), "Asset Change Report");
    },
  },
  components: {
    breadcrumbComp,
    BackToTop,
    exportLimit,
  },
};
